import { Box, Spinner } from '@apia/theme';

export const IsLoadingRenderer = () => {
  return (
    <Box className="responsiveTable__isLoading">
      <Spinner />
    </Box>
  );
};
